module.exports = __webpack_public_path__ + "static/img/img-4-4.55fa379.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-4-4.png
// module id = +QQY
// module chunks = 0